module.exports = __webpack_public_path__ + "assets/img/gift-3-d-67c0f7b1.png";